import { legacy_createStore as createStore, combineReducers, applyMiddleware, compose } from 'redux'
import { thunk } from 'redux-thunk'
import { usersReducer } from './reducers/auth/usersReducer'
import { clientsReducer } from './reducers/other/clientsReducer'
import { policiesReducer } from './reducers/other/policiesReducer'
import { sinestersReducer } from './reducers/other/sinestersReducer'
import { receiptsReducer } from './reducers/other/receiptsReducer'
import { documentsReducer } from './reducers/other/documentsReducer'
import { companiasReducer } from './reducers/other/companiasReducer'
import { sucursalsReducer } from './reducers/other/sucursalsReducer'
import { categoriesReducer } from './reducers/other/categoriesReducer'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose
  }
}

const intialState = {}
const appReducer = combineReducers({
  users: usersReducer,
  clients: clientsReducer,
  policies: policiesReducer,
  sinesters: sinestersReducer,
  receipts: receiptsReducer,
  documents: documentsReducer,
  companias: companiasReducer,
  sucursals: sucursalsReducer,
  categories: categoriesReducer,
})

const reducer = (state: any, action: any) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(reducer, intialState, composeEnhancer(applyMiddleware(thunk)))

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store